<ng-content select="[status]"></ng-content>

<ng-content *ngIf="!isOperating&&!isPromotionImage" select="[actions]"></ng-content>

<div class="card-picture" (mouseenter)="mouseenter.emit()" (mouseleave)="mouseleave.emit()">
    <ig-image [imageUrl]="picture" [placeCategoryList]="placeCategoryList" [class.promotion]="isPromotionImage" [alt]="alt"></ig-image>
    <div class="card-picture-cover">
        <ig-spinner *ngIf="isOperating">
        </ig-spinner>
    </div>
</div>

<ng-container *ngIf="!isPromotionImage">
    <div class="card-title" *ngIf="containTitle">
        <ng-content select="[title]"></ng-content>
    </div>

    <div class="card-detail">
        <ng-content select="[detail]"></ng-content>
    </div>
</ng-container>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/water.fall.container/card/card.component.html